var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01265e-07 15.5013C-0.00251392 6.95545 6.75803 -0.00387113 15.0588 1.61555e-06C23.4237 0.00387436 30.183 6.93479 30.1842 15.5065C30.1842 24.113 23.4287 31.0039 14.9947 31C6.74169 30.9948 0.00251532 24.0291 7.01265e-07 15.5013ZM4.30125 23.0002C7.33137 19.9575 10.921 18.3542 15.1204 18.3581C19.3148 18.362 22.8956 19.9795 25.888 22.986C29.1168 18.4407 29.24 10.8759 24.1906 5.85688C19.2293 0.925586 11.4478 0.791332 6.34061 5.53286C1.1693 10.3351 0.856228 18.0057 4.30125 23.0002Z",
    fill: "#F68140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1128 16.534C11.7772 16.534 9.06518 13.7611 9.06141 10.3467C9.05763 6.92445 11.7558 4.13995 15.0852 4.1335C18.4397 4.12704 21.1479 6.92445 21.1353 10.3841C21.124 13.7598 18.407 16.534 15.1116 16.5327L15.1128 16.534Z",
    fill: "#F68140"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.1842,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccount);
export default __webpack_public_path__ + "static/media/manage_account.f6f08707ee325406ca60acc306671b94.svg";
export { ForwardRef as ReactComponent };